<ngb-alert class="content spacing remove-close-button" type="danger" dismissible="false" *ngIf="errorMessage">
    <pre [innerHTML]="errorMessage" (dblclick)="toggle()"></pre>
    <pre [innerText]="errorStringified" *ngIf="show"></pre>
</ngb-alert>
